import React from 'react'

const ContributorCard = ({ contributor }) => {
  const getInitials = (name) => {
    return name
      .split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2)
  }

  const getAvatarColor = (name) => {
    const colors = [
      'from-red-500 to-pink-500',
      'from-blue-500 to-cyan-500',
      'from-green-500 to-emerald-500',
      'from-purple-500 to-violet-500',
      'from-orange-500 to-yellow-500',
      'from-indigo-500 to-blue-500',
      'from-teal-500 to-green-500',
      'from-pink-500 to-rose-500',
    ]
    const index = name.length % colors.length
    return colors[index]
  }

  return (
    <a
      href={contributor.profileLink}
      target='_blank'
      rel='noopener noreferrer'
      className='block'
    >
      <div className='glass-card rounded-2xl p-6 hover:scale-105 transition-all duration-300 group animate-float relative cursor-pointer'>
        {/* Header with Avatar */}
        <div className='flex items-start space-x-4 mb-4'>
          <div
            className={`w-16 h-16 rounded-full bg-gradient-to-br ${getAvatarColor(
              contributor.fullName
            )} flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300`}
          >
            <span className='text-white font-bold text-lg'>
              {getInitials(contributor.fullName)}
            </span>
          </div>
          <div className='flex-1'>
            <h3 className='text-xl font-bold text-white mb-1 group-hover:text-blue-200 transition-colors'>
              {contributor.fullName}
            </h3>
            <p className='text-white/80 text-sm mb-1'>{contributor.role}</p>
            <p className='text-white/60 text-sm'>{contributor.affiliation}</p>
          </div>

          {/* Replacing inner anchor with a non-interactive element */}
          <div
            className='p-2 rounded-lg bg-white/10 text-white/80 hover:bg-white/20 transition-all duration-300'
            title={`Visit ${contributor.fullName} profile`}
          >
            <svg
              className='w-4 h-4'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
              />
            </svg>
          </div>
        </div>

        {/* IO */}
        <div className='space-y-3'>
          <h4 className='text-white/90 font-semibold text-sm flex items-center space-x-2'>
            <svg
              className='w-4 h-4'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
              />
            </svg>
            <span>Input/Output</span>
          </h4>
          <div className='flex flex-wrap gap-2'>
            {contributor.expertise.map((area, index) => (
              <span
                key={index}
                className='px-3 py-1 bg-gradient-to-r from-emerald-500/20 to-blue-500/20 text-white/90 text-sm rounded-lg border border-white/20 backdrop-blur-sm'
              >
                {area}
              </span>
            ))}
          </div>
        </div>

        {/* View Profile button replaced by a styled div */}
        <div className='mt-6 pt-4 border-t border-white/10'>
          <div className='w-full py-2 px-4 bg-gradient-to-r from-blue-500/20 to-purple-500/20 hover:from-blue-500/30 hover:to-purple-500/30 text-white text-sm font-medium rounded-lg border border-white/20 transition-all duration-300 backdrop-blur-sm text-center'>
            View Docs
          </div>
        </div>

        {/* Decorative Elements */}
        <div className='absolute top-4 right-4 w-12 h-12 bg-gradient-to-br from-emerald-500/10 to-blue-500/10 rounded-full blur-lg opacity-50 group-hover:opacity-75 transition-opacity'></div>

        {/* Hover Effect Overlay */}
        <div className='absolute inset-0 bg-gradient-to-r from-emerald-500/5 to-blue-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none'></div>
      </div>
    </a>
  )
}

export default ContributorCard
